//#region libraries
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

// bootstrap
import { Col, Row } from 'react-bootstrap';

// custom components
import { NewScreen, Title as CustomTitle } from '_atoms';


// scenes
import TransactionInformation from './transaction-information';

//redux
import { useDispatch } from 'react-redux';
import { getTransaction } from '_redux/slices/marketplace/transaction';
//#endregion

const ProductSales = () => {
    const { transactionId } = useParams(); // Get transaction ID from URL
    const dispatch = useDispatch();


    useEffect(() => {
        if (transactionId) {
            dispatch(getTransaction(transactionId));
        }
    }, [transactionId, dispatch]);

    return (
        <NewScreen>

            {/* Titles */}
            <Row>
                <Col>
                    <CustomTitle subtitle={"Product Sales"} />
                </Col>
            </Row>

            transaction ? <TransactionInformation /> : <p>Loading transaction details...</p>

        </NewScreen>
    )
};

export default ProductSales;
